export function Medal({
  position,
  className,
}: {
  position: number;
  className?: string;
}) {
  let label: string;
  let emoji: string;

  switch (position) {
    case 1:
      label = 'primero';
      emoji = '🥇';
      break;
    case 2:
      label = 'segundo';
      emoji = '🥈';
      break;
    case 3:
      label = 'tercero';
      emoji = '🥉';
      break;
    default:
      return null;
  }

  return (
    <span aria-label={label} role="img" className={className}>
      {emoji}
    </span>
  );
}
